import { KoButton, KoDataTableEdit, KoForm, KoNano } from 'packages';
import KoIcon from '@kwapio/icons';
import { useState } from 'react';
import { useSelector } from "react-redux";
import styles from './curd.module.scss';

function SprintGoalCrud({ form, handleFinish, initialValues }) {
  const groups = useSelector(state => state.groups);

  let ds=  initialValues?.sprintGoal?.length > 0 ? initialValues?.sprintGoal :  [{
    key: KoNano('SPG'),
    team: null,
    description: null

  }];
  const [dataSource, setDataSource] = useState(ds);
 
  const handleDelete = (key) => {
    let newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    if(newData.length === 0){
      newData =[{
        key: KoNano('SPG'),
        team: null,
        description: null
      }];
    }
    handleSave(newData);
  };

  const columns = [
    {
      dataIndex: 'team',
      title: 'Team',
      width: 200,
      editable: true,
      widget: 'options',
      options: groups['data']?.map((group) => ({
        label: group.name,
        value: group?.groupId
      })),
      placeholder: 'Select Team'
    },
    {
      dataIndex: 'description',
      title: 'Description',
      width: 400,
      editable: true,
      widget: 'richText',
      placeholder: 'Enter description'
    },
    {
      title: ` `,
      dataIndex: 'operation',
      width: 40,
      render: (_, record, i) =>
        dataSource.length >= 1 ? (
          <div className={'editTableCol'}>
            <KoButton icon={<KoIcon width={12} height={12} name={'DeleteOutlined'} />} className={styles.actionBtn} onClick={() => handleDelete(record?.key)} label="" />
            {dataSource?.length === (i+1) && <KoButton icon={<KoIcon color={`var(--palette-gray-7)`} width={17} height={17} name={'PlusOutlined'} />} className={styles.actionBtn} onClick={() => handleAdd(record?.key)} label={``} />}
          </div>
        ) : null
    }
  ];

  const handleAdd = () => {
    const newData = {
      key: KoNano('SPG'),
      team: ``,
      description: ''
    };
    setDataSource([...dataSource, newData]);
  };


  const handleSave = (newData) => {
    let data = form.getFieldsValue();
    data['sprintGoal'] = newData;
    form.setFieldsValue({...data});
    setDataSource(newData);
  };


  return (
    <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
      <KoForm.Item name={'sprintGoal'}>
        <KoDataTableEdit
          dataSource={dataSource}
          form={form}
          onSave={handleSave}
          defaultColumns={columns} />
      </KoForm.Item>
    </KoForm>
  );
};

export default SprintGoalCrud;